module.exports = __webpack_public_path__ + "recruit-new-members.svg?6400987699d021c4d0c58ab2242a4aed";